// extracted by mini-css-extract-plugin
export default {"price__parent":"PriceMenu_price__parent__s1zDn","clear_text":"PriceMenu_clear_text__iytKT","done_btn":"PriceMenu_done_btn__ET7eX"};